import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { ChatState } from '../../types'

export const removeParticipantToGroupAction = createAsyncAction(
  '@chat/REMOVE_PARTICIPANT_TO_GROUP_REQUEST',
  '@chat/REMOVE_PARTICIPANT_TO_GROUP_SUCCESS',
  '@chat/REMOVE_PARTICIPANT_TO_GROUP_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingRemoveParticipantToGroup: true
})

const success = (state: ChatState, action: ActionType<typeof removeParticipantToGroupAction.success>): ChatState => {
  const { updatedChatData } = action.payload
  return {
    ...state,
    activeChat: { ...state.activeChat, ...updatedChatData },
    isSuccessOnRemoveParticipantToGroup: true,
    isLoadingRemoveParticipantToGroup: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingRemoveParticipantToGroup: false,
  isErrorOnRemoveParticipantToGroup: true
})

export const removeParticipantToGroupHandle = { asyncAction: removeParticipantToGroupAction, request, success, failure }
